// DOM and formatting helpers shared by every module. Lifted from the single-chip
// viewer (symtpu/tools/trace_viewer/viewer.js) and extended with time formatting.

export const $ = (sel, root) => (root || document).querySelector(sel);
export const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

export function el(tag, cls, text) {
  const n = document.createElement(tag);
  if (cls) n.className = cls;
  if (text != null) n.textContent = text;
  return n;
}

export function svgEl(tag, attrs) {
  const n = document.createElementNS("http://www.w3.org/2000/svg", tag);
  for (const k in attrs) n.setAttribute(k, attrs[k]);
  return n;
}

export function bytes(b) {
  if (b == null) return "?";
  if (b >= 1048576) return (b / 1048576).toFixed(b % 1048576 ? 1 : 0) + " MiB";
  if (b >= 1024) return (b / 1024).toFixed(b % 1024 ? 1 : 0) + " KiB";
  return b + " B";
}

// Picoseconds as a human time: the unit chosen so the number stays short.
export function fmtPs(ps, digits = 3) {
  if (ps == null || Number.isNaN(ps)) return "?";
  const a = Math.abs(ps);
  if (a >= 1e9) return (ps / 1e9).toFixed(digits) + " ms";
  if (a >= 1e6) return (ps / 1e6).toFixed(digits) + " us";
  if (a >= 1e3) return (ps / 1e3).toFixed(digits) + " ns";
  return ps.toFixed(0) + " ps";
}

export function fmtNs(ns) {
  if (ns == null) return "?";
  if (ns >= 1e9) return (ns / 1e9).toFixed(3) + " s";
  if (ns >= 1e6) return (ns / 1e6).toFixed(3) + " ms";
  if (ns >= 1e3) return (ns / 1e3).toFixed(3) + " us";
  return ns + " ns";
}

export function fmtInt(n) {
  return n == null ? "?" : n.toLocaleString("en-US");
}

// One tooltip element for the page, positioned near the pointer.
let tip = null;
export function showTip(x, y, html) {
  if (!tip) {
    tip = el("div", "tip");
    document.body.appendChild(tip);
  }
  tip.innerHTML = html;
  tip.style.display = "block";
  const w = tip.offsetWidth, h = tip.offsetHeight;
  const px = x + 14 + w > window.innerWidth ? x - w - 8 : x + 14;
  const py = y + 14 + h > window.innerHeight ? y - h - 8 : y + 14;
  tip.style.left = px + "px";
  tip.style.top = py + "px";
}
export function hideTip() {
  if (tip) tip.style.display = "none";
}

export function esc(s) {
  return String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
}

// Last index i with a[i] <= v (a sorted ascending), or -1.
export function lowerIndex(a, v, n = a.length) {
  let lo = 0, hi = n;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (a[mid] <= v) lo = mid + 1; else hi = mid;
  }
  return lo - 1;
}

// First index i with a[i] >= v, or n.
export function upperIndex(a, v, n = a.length) {
  let lo = 0, hi = n;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (a[mid] < v) lo = mid + 1; else hi = mid;
  }
  return lo;
}

export function debounce(fn, ms) {
  let t = null;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), ms);
  };
}

export function clamp(v, lo, hi) {
  return v < lo ? lo : v > hi ? hi : v;
}
